import styled from 'styled-components';
// import theme from '../theme';

const DataSetResponseStatusStyles = styled.div``;

export default DataSetResponseStatusStyles;
